import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from '@aws-amplify/auth/cognito';
import { CookieStorage } from 'aws-amplify/utils';

const path = window.location.pathname;
const isDriver = path.startsWith('/driver');

const {
    VITE_USER_POOL_ID,
    VITE_USER_POOL_WEB_CLIENT_ID,
    VITE_IDENTITY_POOL_ID,
    VITE_USER_POOL_REGION,
    VITE_IOT_ENDPOINT,
} = import.meta.env;

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: isDriver ? undefined : VITE_USER_POOL_ID!,
            userPoolClientId: isDriver ? undefined : VITE_USER_POOL_WEB_CLIENT_ID!,
            identityPoolId: isDriver ? VITE_IDENTITY_POOL_ID : undefined,
            allowGuestAccess: isDriver,
            signUpVerificationMethod: 'code',
        },
    },
    ...(isDriver && {
        PubSub: {
            region: VITE_USER_POOL_REGION,
            endpoint: `wss://${VITE_IOT_ENDPOINT}/mqtt`,
        },
    }),
});

cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage());
